// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36gQT","question":"styles_question__1Q9Ba","inputVisibleButton":"styles_inputVisibleButton__2ZWOa","note":"styles_note__qVhtk"};